import React, { useEffect, useMemo, useState } from "react";
import { Navigate } from "react-router-dom";
/*
import { useAppDispatch, useAppSelector } from "../../../Redux/Hooks";
import { AddAmountInWalletAPI, getTransactionHistoryAPI } from "../../../Redux/ApiCalls/Dashboard/WallteAPI";
import LoadingDots from "../../atoms/Utlis/LoadingDots";
import sendFirebaseEvent from "../../../analytics/FirebaseAnalytics";
import { completePaymentAPI } from "../../../Redux/ApiCalls/Dashboard/PaymentAPI";
*/

export default function WalletComponent({ perPage = 10 }) {
  return <Navigate to="/dashboard/whatsapp/billing" replace />;
}

/*
export function OriginalWalletComponent({ perPage = 10 }) {
  const [page, setPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState("");
  const dispatch = useAppDispatch()
  const { loading, order, wallet } = useAppSelector(state => state.wallet)
  const { user } = useAppSelector(
    (state) => state.auth
  );
  const transactions = useMemo(() => wallet?.transactions || [], [wallet?.transactions]);
  const total = transactions.length;
  const totalPages = Math.max(1, Math.ceil(total / perPage));


  useEffect(() => {
    if (!wallet.isTransactionFetched) {
      dispatch(getTransactionHistoryAPI())
    }
  }, [wallet.isTransactionFetched])
  useEffect(() => {
    console.log(wallet.transactions)
  }, [wallet.transactions])

  useEffect(() => {
    if (order.id) {
      const options = {
        key: "rzp_test_gQAw4fxmsaihmF",
        currency: "INR",
        name: "Kwik Media",
        description: `Adding ${order.amount} in Wallet`,
        order_id: order.id,
        handler: async function (response: any) {
          sendFirebaseEvent(
            "Subscription",
            "User_Interaction",
            "Payment_Completed",
            `wallet : ${amount}`
          );
          dispatch(
            completePaymentAPI({
              payment_id: response.razorpay_payment_id,
              order_id: response.razorpay_subscription_id,
              signature: response.razorpay_signature,
              settlement_for: "wallet",
            })
          );
        },
        prefill: {
          name: `${user?.name}`,
          email: `${user?.email}`,
          contact: `${user?.phone_number}`,
        },
        notes: {
          address: " Kwik Media Address.",
        },
        theme: {
          color: "#AE2AB1",
        },
      };

      const rzp = new (window as any).Razorpay(options);

      rzp.on("payment.failed", (response: any) => {
        console.log("payment failed", response);
      });

      rzp.on("payment.cancelled", () => {
        alert("Payment cancelled");
        // dispatch(cancelPayment());
        // Handle payment cancellation
      });
      rzp.open();
    }
  }, [order.id, order.amount])

  const visible = useMemo(() => {
    const start = (page - 1) * perPage;
    return transactions.slice(start, start + perPage);
  }, [page, perPage, transactions]);

  function goTo(newPage: any) {
    if (newPage < 1) newPage = 1;
    if (newPage > totalPages) newPage = totalPages;
    setPage(newPage);
  }

  const handleAddAmount = () => {
    if (Number(amount) > 0) {
      const formData = new FormData();
      formData.append("amount", amount)
      dispatch(AddAmountInWalletAPI(formData))
    }
  }


  return (
    <div>
      <div className='flex items-center justify-center relative'>
        <div className='text-xl font-bold'>Wallet</div>
        <div className='border border-[#C62BC9] py-2 px-4 rounded-xl absolute right-[5%] linear-text font-bold cursor-pointer' onClick={() => { setShowModal(true) }}>Add Amount</div>
      </div>

      <div className="mt-8 flex items-center justify-center p-6" style={{ background: "transparent" }}>


        <div className="w-full max-w-3xl bg-white/5 backdrop-blur-md rounded-2xl p-6 shadow-lg" style={{ border: `1px solid #C62BC9` }}>
          <header className="flex items-center justify-between mb-6">
            <div>
              <h1 className="text-2xl font-semibold linear-text" >
                Wallet
              </h1>
            </div>
            <div className="text-right">
              <p className="text-xs text-gray-800">Available balance</p>
              <p className="text-2xl font-bold linear-text">₹{wallet.balance ?? 0}</p>
            </div>
          </header>

          <section className="mb-4">
            <h2 className="text-lg font-medium mb-2 linear-text" >
              Recent transactions
            </h2>

            <div className="divide-y divide-gray-700 rounded-lg overflow-hidden">
              {wallet.transactions?.length === 0 ? (
                <div className="p-4 text-center text-gray-400">No transactions</div>
              ) : (
                wallet.transactions?.map((tx) => (
                  <div key={tx.transaction_id} className="flex items-center justify-between p-4">
                    <div>
                      <div className="flex items-center gap-3">
                        <span className={`inline-flex items-center justify-center w-10 h-10 rounded-md text-sm font-medium`} style={{ background: tx.type === "credit" ? `#C62BC922` : `#C62BC911`, color: `#C62BC9` }}>
                          {tx.type === "credit" ? "+" : "-"}
                        </span>
                        <div>
                          <div className="text-sm font-medium">{tx.description}</div>
                          <div className="text-xs text-gray-400">{new Date(tx.created_at).toLocaleString()}</div>
                        </div>
                      </div>
                    </div>

                    <div className="text-right">
                      <div className={`text-sm font-semibold ${tx.type === "credit" ? "text-green-800" : "text-red-600"}`}>
                        {tx.type === "credit" ? "+" : "-"}₹{tx.amount}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </section>

          // Pagination controls
          <footer className="mt-4 flex items-center justify-between">
            <div className="text-sm !text-gray-800">
              Showing <span className="font-medium text-gray-800">{(page - 1) * perPage + 1}</span> - <span className="font-medium text-gray-800">{Math.min(page * perPage, total)}</span> of <span className="font-medium text-gray-800">{total}</span>
            </div>

            <div className="flex items-center gap-2">
              <button
                onClick={() => goTo(page - 1)}
                className="px-3 py-1 rounded-md border text-sm linear-text"
                style={{ borderColor: `#C62BC9`, background: 'transparent' }}
                disabled={page === 1}
              >
                Prev
              </button>

              // Page numbers (compact)
              <div className="hidden sm:flex items-center gap-1">
                {Array.from({ length: totalPages }).map((_, i) => {
                  const p = i + 1;
                  const active = p === page;
                  return (
                    <button
                      key={p}
                      onClick={() => goTo(p)}
                      className={`px-3 py-1 rounded-md text-sm ${active ? 'font-semibold' : 'text-gray-800'}`}
                      style={{ border: active ? `1px solid ${`#C62BC9`}` : '1px solid transparent', color: active ? `#C62BC9` : undefined, background: 'transparent' }}
                    >
                      {p}
                    </button>
                  );
                })}
              </div>

              <button
                onClick={() => goTo(page + 1)}
                className="px-3 py-1 rounded-md border text-sm linear-text"
                style={{ borderColor: `#C62BC9`, background: 'transparent' }}
                disabled={page === totalPages}
              >
                Next
              </button>
            </div>
          </footer>
        </div>
      </div>
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-sm shadow-lg relative">
            <h3 className="text-lg font-semibold mb-4 linear-text" >Add Amount</h3>
            <form className="space-y-4">
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="Enter amount"
                className="w-full border rounded-md p-2 focus:outline-none"
                style={{ borderColor: `#C62BC9` }}
                required
              />
              {
                loading ? <div className="w-full mx-auto"> <LoadingDots /></div> :
                  <div className="flex justify-end gap-2">
                    <button
                      type="button"
                      onClick={() => setShowModal(false)}
                      className="px-4 py-2 rounded-md text-sm linear-text"
                      style={{ border: `1px solid #C62BC9`, background: 'transparent' }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="px-4 py-2 rounded-md text-sm text-white bg-gradient-to-r from-[#FFC951] to-[#C94DAA]"
                      onClick={() => { handleAddAmount() }}
                    >
                      Add
                    </button>
                  </div>
              }

            </form>
          </div>
        </div>
      )}
    </div>
  );
}
*/



